import React, { useState } from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { RestReportBean } from "../ds/client_ds.js";
import {
  PostedARRegisterCriteriaBean,
  PostedARRegisterPrintRequest,
  RestPageListBean,
} from "../ds/ds.js";
import { AddIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupARModule,
  PopupCustomerModule,
  PopupInvoiceModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { ReportService } from "../services/ReportService.js";

import {
  AlertToolBox,
  DatePickerComponent_adv,
  MultiViewPopup,
  ProgressBar,
  ShowError,
  ColumnDefinition
} from "../gui_components/UIComponents.js";
import CustomTable from "../gui_components/CustomTable.js";
class PostedARDayRegister extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Posted AR Day Register Inquiry",
      isShowExecuteButton: true,
      alertMessage: "",
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowLineTable: false,
      isShowExitButton: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      error_list: [],
      inquiryDataList: [],
      summaryData: null,
      criteria: new PostedARRegisterCriteriaBean(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowInvoiceModule: false,
      isShowCustomerModule: false,
      isShowARModule: false,
      moduleForPopup: [],
      inquiryData: null,
      detailDataList: [],
      viewDetailsTable: false,
      isDisableFields: false,
      order: "asc",
      sortField: "",
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    let criteria = this.state.criteria;
    let currentDate = new Date();
    currentDate = currentDate.toLocaleDateString("sv-SE");
    var date = new Date();
    var firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    firstDayOfMonth = firstDayOfMonth.toLocaleDateString("sv-SE");
    criteria.startPostedDate = firstDayOfMonth;
    criteria.endPostedDate = currentDate;
    this.setState({ criteria: criteria });
  }
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    this.loadPostedARDayRegisterInquiryList(criteria);
  };
  loadPostedARDayRegisterInquiryList = (criteria) => {
    if (SecurityAccessManager.PostedARDayRegisterInquiry_IsAccessible()) {
      ReportService.inquirePostedARRegister(
        criteria,
        this.loadPostedARDayRegisterPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadPostedARDayRegisterPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      let arDataList = [];
      let inquiryDataList = response.data.result;
      if (!isEmptyArray(response.data.result.summayInfos)) {
        arDataList = response.data.result.summayInfos;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        inquiryDataList: arDataList,
        inquiryData: inquiryDataList,
        isShowHideButton: false,
        isShowAddButton: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generatePDF = () => {
    this.generateReport(1);
  };
  generateExcel = () => {
    this.generateReport(2);
  };
  generateReport = (reportType) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new PostedARRegisterPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generate Report...",
    });
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.PostedARDayRegisterInquiryPDFReport_IsAccessible()
      ) {
        ReportService.generatePostedARRegisterPrintReport(
          listRequest,
          this.generatePostedARDayRegisterPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.PostedARDayRegisterInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generatePostedARRegisterPrintReport(
          listRequest,
          this.generatePostedARDayRegisterPageResponseForExcel,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generatePostedARDayRegisterPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
    generatePostedARDayRegisterPageResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
         let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
              window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new PostedARRegisterCriteriaBean();
    criteria.companyCode = this.companyCode;
    let currentDate = new Date();
    currentDate = currentDate.toLocaleDateString("sv-SE");
    var date = new Date();
    var firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    firstDayOfMonth = firstDayOfMonth.toLocaleDateString("sv-SE");
    criteria.startPostedDate = firstDayOfMonth;
    criteria.endPostedDate = currentDate;
    this.setState({ criteria: criteria });
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let criteria = new PostedARRegisterCriteriaBean();
    criteria.companyCode = this.companyCode;
    let currentDate = new Date();
    currentDate = currentDate.toLocaleDateString("sv-SE");
    var date = new Date();
    var firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    firstDayOfMonth = firstDayOfMonth.toLocaleDateString("sv-SE");
    criteria.startPostedDate = firstDayOfMonth;
    criteria.endPostedDate = currentDate;
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
    });
    this.hideAlertCallBack();
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowCustomerModule: isOpen,
      isShowInvoiceModule: isOpen,
      isShowARModule: isOpen,
      moduleForPopup: [],
    });
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowLineTable: isShowPopup,
    });
  };
  viewDetails = (e, rowData, list) => {
    if (e.detail === 1) {
      let detailDataList = this.state.detailDataList;
      detailDataList = list.detailsInfo;
      this.setState({ isShowLineTable: true, detailDataList: detailDataList });
    }
  };
  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewCustomerModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewARModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowARModule: true,
          moduleForPopup: (
            <PopupARModule code={code} onModuleExit={this.onPopupModalExit} />
          ),
        });
      }
    }
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  docConvertor = (arLine, type, val) => {
    let document = "";
    let date = "";
    if (arLine.cardPaidAmount != null && arLine.cardPaidAmount > 0) {
      if (!isEmptyString(arLine.paidCreditCardNumber)) {
        document = "C.Card# :" + arLine.paidCreditCardNumber.substr(-4);
      } else if (!isEmptyString(arLine.paidDebitCardNumber)) {
        document = "D.Card# :" + arLine.paidDebitCardNumber.substr(-4);
      }
    }
    if (arLine.cashPaidAmount != null && arLine.cashPaidAmount > 0) {
      if (!isEmptyString(arLine)) document = "Cash#";
    }
    if (arLine.checkPaidAmount != null && arLine.checkPaidAmount > 0) {
      if (!isEmptyString(arLine.paidCheckNumber))
        document = "Check# :" + arLine.paidCheckNumber;
      date = arLine.checkDate;
    }
    if (arLine.wirePaidAmount != null && arLine.wirePaidAmount > 0) {
      if (!isEmptyString(arLine.paidWireTransferReferenceNumber))
        document = "Wire# :" + arLine.paidWireTransferReferenceNumber;
      date = arLine.wireTransferDate;
    }
    if (
      arLine.autoClearingHouseAmount != null &&
      arLine.autoClearingHouseAmount > 0
    ) {
      if (!isEmptyString(arLine.paidAutoClearingHouseReferenceNumber))
        document = "ACH# :" + arLine.paidAutoClearingHouseReferenceNumber;
      date = arLine.achDate;
    }
    if (
      arLine.creditMemoPaidAmount != null &&
      arLine.creditMemoPaidAmount > 0
    ) {
      if (!isEmptyString(arLine.paidCreditMemoNumber))
        document = document + " - C.M# :" + arLine.paidCreditMemoNumber;
    }
    let returnValue = "";
    if (type == 1) {
      returnValue = document;
    } else if (type == 2) {
      returnValue = date;
    }
    return returnValue;
  };
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("", <AddIcon />, false)
        .setStyleDetails("center", "", "", "wt-2", "wt-2")
        .setClickDetails(true, true, this.viewDetails, <AddIcon />)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ARDate", "accountReceivableDate", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Check Amount", "checkPaidAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setSubHeaderDetails(true, "checkPaidAmount")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Cash Amount", "cashPaidAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setSubHeaderDetails(true, "cashPaidAmount")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Wire Amount", "wirePaidAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setSubHeaderDetails(true, "wirePaidAmount")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ACH Amount", "achAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setSubHeaderDetails(true, "achAmount")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Card Amount", "cardPaidAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setSubHeaderDetails(true, "cardPaidAmount")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Credit Amount", "creditMemoPaidAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setSubHeaderDetails(true, "creditMemoPaidAmount")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Total Amount", "totalPaidAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setSubHeaderDetails(true, "totalPaidAmount")
    );
    return columns;
  };
  // lineDetailsColumns = (val) => {
  //   const columns = new Array();
  //   columns.push(
  //     new ColumnDefinition()
  //       .setDetails("PostedDate", "accountReceivablePostedDate", true)
  //       .setStyleDetails("left", "", "", "wt-4", "wt-4")
  //   );
  //   columns.push(
  //     new ColumnDefinition()
  //       .setDetails("Customer", "customerCode", true)
  //       .setStyleDetails("left", "4", "", "wt-4", "wt-4")
  //       .setClickDetails(true, false, this.viewCustomerModule, null)
  //   );
  //   columns.push(
  //     new ColumnDefinition()
  //       .setDetails("CustomerName", "customerName", true)
  //       .setStyleDetails("left", "6", "", "wt-4", "wt-4")
  //   );
  //   columns.push(
  //     new ColumnDefinition()
  //       .setDetails("AR#", "accountReceivableNumber", true)
  //       .setStyleDetails("left", "4", "", "wt-4", "wt-4")
  //       .setClickDetails(true, false, this.viewARModule, null)
  //   );
  //   columns.push(
  //     new ColumnDefinition()
  //       .setDetails("Invoice#", "invoiceNumber", true)
  //       .setStyleDetails("left", "4", "", "wt-4", "wt-4")
  //       .setClickDetails(true, false, this.viewInvoiceModule, null)
  //   );
  //   columns.push(
  //     new ColumnDefinition()
  //       .setDetails("Customer PO#", "customerPurchaseOrderNumber", true)
  //       .setStyleDetails("left", "", "", "wt-4", "wt-4")
  //   );
  //   columns.push(
  //     new ColumnDefinition()
  //       .setDetails("SalesPerson", "salesPersonDetails", true)
  //       .setStyleDetails("left", "", "", "wt-4", "wt-4")
  //   );
  //   columns.push(
  //     new ColumnDefinition()
  //       .setDetails("Invoice Date", "invoiceDate", true)
  //       .setStyleDetails("left", "", "", "wt-4", "wt-4")
  //   );
  //   columns.push(
  //     new ColumnDefinition()
  //       .setDetails("TenderAmt", "tenderAmount", true, true)
  //       .setStyleDetails("right", "", "", "wt-4", "wt-4")
  //   );
  //   columns.push(
  //     new ColumnDefinition()
  //       .setDetails("CreditAmt", "creditMemoPaidAmount", true, true)
  //       .setStyleDetails("right", "", "", "wt-4", "wt-4")
  //   );
  //   columns.push(
  //     new ColumnDefinition()
  //       .setDetails("TotalAmt", "totalPaidAmount", true, true)
  //       .setStyleDetails("right", "", "", "wt-4", "wt-4")
  //   );
  //   columns.push(
  //     new ColumnDefinition()
  //       .setDetails("Documents #", "Documents", true, true)
  //       .setGraphDetails(true, this.docHandler)
  //       .setStyleDetails("right", "", "", "wt-4", "wt-4")
  //   );
  //   columns.push(
  //     new ColumnDefinition()
  //       .setDetails("Doc Date", "Doc Date", true, true)
  //       .setGraphDetails(true, this.docDateHandler)
  //       .setStyleDetails("right", "", "", "wt-4", "wt-4")
  //   );
  //   return columns;
  // };
  // docHandler = (e,rowData,val) => {
  //   let doc = this.docConvertor(rowData, 2);
  //   doc = String(doc);
  //   return  doc;
  // };
  // docDateHandler = (e,rowData,val) => {
  //   let docDate = this.docConvertor(rowData, 2);
  //   docDate = String(docDate);
  //   return docDate = String(docDate);
  // };

  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let inquiryData = this.state.inquiryData;
    let detailDataList = this.state.detailDataList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <CriteriaView {...this.state} onChange={this.onChange} />
        {this.state.isInquiryDatasFound && (
          <div className="mt-3">
            <CustomTable
              data={inquiryDataList}
              columns={this.inquiryColumns()}
              subHeaderData={inquiryData}
            />
          </div>
        )}
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowLineTable}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Line Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          content={
            <div className="div_default">
              {/* <div className="mt-3">
                <CustomTable
                  data={detailDataList}
                  columns={this.lineDetailsColumns()}
                />
              </div> */}
              <Table id="fabrics_tables">
                <thead>
                  <tr>
                    <th
                      onClick={(e) =>
                        this.handleSortingDetailDataChange(
                          e,
                          "accountReceivablePostedDate"
                        )
                      }
                    >
                      PostedDate
                      {this.state.order === "desc" &&
                        this.state.sortField === "accountReceivablePostedDate" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingDetailDataChange(e, "customerCode")
                      }
                    >
                      Customer#
                      {this.state.order === "desc" &&
                        this.state.sortField === "customerCode" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingDetailDataChange(e, "customerName")
                      }
                    >
                      Customer Name
                      {this.state.order === "desc" &&
                        this.state.sortField === "customerName" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingDetailDataChange(
                          e,
                          "accountReceivableNumber"
                        )
                      }
                    >
                      AR#
                      {this.state.order === "desc" &&
                        this.state.sortField === "accountReceivableNumber" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingDetailDataChange(e, "invoiceNumber")
                      }
                    >
                      Invoice#
                      {this.state.order === "desc" &&
                        this.state.sortField === "invoiceNumber" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingDetailDataChange(
                          e,
                          "customerPurchaseOrderNumber"
                        )
                      }
                    >
                      Customer PO#
                      {this.state.order === "desc" &&
                        this.state.sortField === "customerPurchaseOrderNumber" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingDetailDataChange(
                          e,
                          "salesPersonDetails"
                        )
                      }
                    >
                      SalesPerson
                      {this.state.order === "desc" &&
                        this.state.sortField === "salesPersonDetails" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingDetailDataChange(e, "invoiceDate")
                      }
                    >
                      Invoice Date
                      {this.state.order === "desc" &&
                        this.state.sortField === "invoiceDate" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingDetailDataChange(e, "tenderAmount")
                      }
                    >
                      TenderAmt
                      {this.state.order === "desc" &&
                        this.state.sortField === "tenderAmount" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingDetailDataChange(
                          e,
                          "creditMemoPaidAmount"
                        )
                      }
                    >
                      CreditAmt
                      {this.state.order === "desc" &&
                        this.state.sortField === "creditMemoPaidAmount" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingDetailDataChange(e, "totalPaidAmount")
                      }
                    >
                      TotalAmt
                      {this.state.order === "desc" &&
                        this.state.sortField === "totalPaidAmount" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th>Documents #</th>
                    <th>Doc Date</th>
                  </tr>
                </thead>
                {detailDataList != null && (
                  <tbody>
                    {detailDataList.map((data, index) => (
                      <tr key={index}>
                        <td>{data.accountReceivablePostedDate}</td>
                        <td>
                          <Button
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.viewCustomerModule(e, data.customerCode)
                            }
                          >
                            {data.customerCode}
                          </Button>
                        </td>
                        <td>{data.customerName}</td>
                        <td>
                          <Button
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.viewARModule(e, data.accountReceivableNumber)
                            }
                          >
                            {data.accountReceivableNumber}
                          </Button>
                        </td>
                        <td>
                          <Button
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.viewInvoiceModule(e, data.invoiceNumber)
                            }
                          >
                            {data.invoiceNumber}
                          </Button>
                        </td>
                        <td>{data.customerPurchaseOrderNumber}</td>
                        <td>{data.salesPersonDetails}</td>
                        <td>{data.invoiceDate}</td>
                        <td className="text-right">
                          {toCommaSeperatedAmount(data.tenderAmount)}
                        </td>
                        <td className="text-right">
                          {toCommaSeperatedAmount(data.creditMemoPaidAmount)}
                        </td>
                        <td className="text-right">
                          {toCommaSeperatedAmount(data.totalPaidAmount)}
                        </td>
                        <td>{this.docConvertor(data, 1)}</td>
                        <td>{this.docConvertor(data, 2)}</td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </Table>
              {detailDataList.length != 0 ? null : (
                <div className="no_Data">{"NO DATA"}</div>
              )}
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowARModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const onChange = (e) => props.onChange(e);
  let criteria = props.criteria;
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          {" "}
          <FormLabel>Start PostedDate</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent_adv
            name="startPostedDate"
            value={criteria.startPostedDate}
            onChange={onChange}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="1">
          <FormLabel>End PostedDate</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent_adv
            name="endPostedDate"
            onChange={onChange}
            value={criteria.endPostedDate}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
      </Row>
    </div>
  );
}
function PostedARDayRegisterInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <PostedARDayRegister {...props} name="" /> <br />
    </div>
  );
}
export default PostedARDayRegisterInquiry;
